/* RESPONSIBLE TEAM: team-standalone */
import { ReactRoute } from 'embercom/lib/react-route';
import SettingsRoute from 'embercom/routes/apps/app/settings/base/base-settings-route';

class ZendeskMessagingRoute extends SettingsRoute {
  reactEnabled() {
    return true;
  }
}

export default ReactRoute(ZendeskMessagingRoute);
